import React from 'react';
import { motion } from 'framer-motion';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/home/HeroSection';
import WhatWeDoSection from '../components/home/WhatWeDoSection';
import TrustedPartnersSection from '../components/home/TrustedPartnersSection';
import ServicesSection from '../components/home/ServicesSection';
import TestimonialsSection from '../components/home/TestimonialsSection';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
      >
        <HeroSection />
        <WhatWeDoSection />
        <ServicesSection />
        <TrustedPartnersSection />
        <TestimonialsSection />
      </motion.main>
      <Footer />
    </div>
  );
};

export default HomePage;
